import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getMember } from "../api/members";
import AddMemoryForm from "../components/AddMemoryForm";
import "./MemberPage.css";

export default function MemberPage() {
  const { id } = useParams();
  const [member, setMember] = useState(null);

  async function reload() {
    const data = await getMember(id);
    setMember(data);
  }

  useEffect(() => {
    reload();
  }, [id]);

  if (!member) return <div>Loading...</div>;

  return (
    <div className="member-container">
      <h1 className="member-name">{member.name}</h1>

      <div id="add-memory-form">
        <AddMemoryForm memberId={id} onAdded={reload} />
      </div>

      <div className="memory-section">
        <h3>Memories</h3>

        {member.memories.length === 0 && <p>No memories yet.</p>}

        <div className="memory-grid">
          {member.memories.map((m, index) => (
            <div className="memory-item" key={index}>
              <strong>{m.title}</strong>
              <br />
              {m.text}
              <br />
              <small>{m.date}</small>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
